var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUpDownSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,2.4140625c0.5351562-0.5332031,1.4648438-0.5332031,2,0l11.2929688,11.2929688l1.4140625-1.4140625L18.4140625,1 C17.125-0.2890625,14.875-0.2890625,13.5859375,1L2.2929688,12.2929688l1.4140625,1.4140625L15,2.4140625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,29.5859375c-0.5351562,0.5332031-1.4648438,0.5332031-2,0L3.7070312,18.2929688l-1.4140625,1.4140625L13.5859375,31 C14.2304688,31.6445312,15.0878906,32,16,32s1.7695312-0.3554688,2.4140625-1l11.2929688-11.2929688l-1.4140625-1.4140625 L17,29.5859375z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDownSmall);
export default __webpack_public_path__ + "static/media/chevron-up-down--small.27b59c360e6a87e8b48e87d1670801c5.svg";
export { ForwardRef as ReactComponent };